import { ReactNode } from 'react';
import { Moment } from 'moment';
import { TableColumn } from './TableHeaders';

export const CoursAndEducationsHeaderMobile = (fm) => {
  return [
    {
      label: fm({ id: 'courseandeducation.table.subheader1' }),
      key: 'courseoreducation',
    },
  ] as TableColumn<CoursAndEducationRowMobile>[];
};

export const CoursAndEducationsHeader = (fm) => {
  return [
    {
      label: fm({ id: 'courseandeducation.table.subheader1' }),
      key: 'courseoreducation',
    },
    {
      label: fm({ id: 'courseandeducation.table.subheader4' }),
      key: 'issued',
      sortFunction: (a, b) => {
        return a.issuedValue.diff(b.issuedValue);
      },
    },
    {
      label: fm({ id: 'courseandeducation.table.subheader5' }),
      key: 'expiry',
      sortFunction: (a, b) => {
        return a.expiryValue.diff(b.expiryValue);
      },
    },
  ] as TableColumn<CoursAndEducationRow>[];
};

export interface CoursAndEducationRowMobile {
  courseoreducation: string;
}

export interface CoursAndEducationRow {
  courseoreducation: string | ReactNode;
  issued: string;
  issuedValue: Moment;
  expiry: string;
  expiryValue: Moment;
}
